module.exports = __webpack_public_path__ + "img/img2.3e900a5c.jpg";